import React from 'react';
import { Poppins, StyledLink } from 'src/common';
import styled from 'styled-components';
import { BaseCard, Row } from '../../styled';
import { Link } from 'react-router-dom';
import Button from 'src/components/form/Button';
import { numeralFormat } from 'src/utils/misc';

const Wrap = styled(BaseCard)`
  .links {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

interface TileRiskyScenariosProps {
  assessmentId: string;
  scenarios: { id: string; name: string; expectedLoss: number }[];
}

export const TileRiskyScenarios: React.FC<TileRiskyScenariosProps> = ({ assessmentId, scenarios }) => {
  return (
    <Wrap>
      <span className="c-title">Most Significant Risks</span>
      <span className="description">These scenarios have the largest contribution to your overall risk posture.</span>

      <div style={{ flex: 1 }} />

      <div className="links">
        {scenarios.map((s, idx) => (
          <Row key={s.id}>
            <Poppins px={14} weight={500} nowrap>
              {idx + 1}. <StyledLink to={`/risk-assessments/${assessmentId}/scenario/${s.id}`}>{s.name}</StyledLink>
            </Poppins>
            <div className="separator" />
            <Poppins weight={600} color="gp1" px={14}>
              {numeralFormat(s.expectedLoss)}
            </Poppins>
          </Row>
        ))}
      </div>

      {!scenarios.length && (
        <>
          <div style={{ flex: 1 }} />
          <Link to={`/risk-assessments/${assessmentId}`}>
            <Button primary>+ Add Risk Scenario</Button>
          </Link>
        </>
      )}
    </Wrap>
  );
};
